var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg2",
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pt",
    d: "m0-.5.16245985.5h-.3249197z",
    fill: "#fff",
    transform: "scale(.062)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use8",
    height: 650,
    transform: "matrix(-.809 -.588 .588 -.809 0 0)",
    width: 1235,
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use10",
    height: 650,
    transform: "matrix(.309 -.951 .951 .309 0 0)",
    width: 1235,
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use12",
    height: 650,
    width: 1235,
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use14",
    height: 650,
    transform: "matrix(.309 .951 -.951 .309 0 0)",
    width: 1235,
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use16",
    height: 650,
    transform: "matrix(-.809 .588 -.588 -.809 0 0)",
    width: 1235,
    xlinkHref: "#pt"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use19",
    height: 650,
    width: 1235,
    x: -0.252,
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use21",
    height: 650,
    width: 1235,
    x: -0.126,
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use23",
    height: 650,
    width: 1235,
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use25",
    height: 650,
    width: 1235,
    x: 0.126,
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use27",
    height: 650,
    width: 1235,
    x: 0.252,
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s6"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use30",
    height: 650,
    width: 1235,
    x: -0.063,
    xlinkHref: "#s5"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use32",
    height: 650,
    width: 1235,
    x: 0.315,
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x4"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use35",
    height: 650,
    width: 1235,
    xlinkHref: "#s6"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use37",
    height: 650,
    width: 1235,
    xlinkHref: "#s5",
    y: 0.054
  }), /*#__PURE__*/React.createElement("use", {
    id: "use39",
    height: 650,
    width: 1235,
    xlinkHref: "#s6",
    y: 0.108
  }), /*#__PURE__*/React.createElement("use", {
    id: "use41",
    height: 650,
    width: 1235,
    xlinkHref: "#s5",
    y: 0.162
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use44",
    height: 650,
    width: 1235,
    xlinkHref: "#x4",
    y: -0.216
  }), /*#__PURE__*/React.createElement("use", {
    id: "use46",
    height: 650,
    width: 1235,
    xlinkHref: "#x4"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use48",
    height: 650,
    width: 1235,
    xlinkHref: "#s6",
    y: 0.216
  })), /*#__PURE__*/React.createElement("path", {
    id: "stripe",
    d: "m0 0h1235v50h-1235z",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3908",
    gradientUnits: "userSpaceOnUse",
    x1: -0.344,
    x2: 0.344,
    y1: -0.003,
    y2: -0.003
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3904",
    offset: 0,
    stopColor: "#2c3c51"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3906",
    offset: 1,
    stopColor: "#2c3c51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7721"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect7723",
    height: 480,
    ry: 48,
    width: 480,
    x: -641.397,
    y: 15.728
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8738",
    d: "m-360 118a208 208 0 1 1 -416 0 208 208 0 1 1 416 0z",
    transform: "matrix(1.154 0 0 1.154 253.987 119.574)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g15642",
    fillRule: "evenodd",
    transform: "translate(-2584.231 -800.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15609",
    d: "m2840.2305 816.41103a240 240 0 0 0 -225.9688 160h451.9727a240 240 0 0 0 -226.0039-160z",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15611",
    d: "m2614.2617 976.41103a240 240 0 0 0 -14.0312 79.99997 240 240 0 0 0 13.9961 80h451.9726a240 240 0 0 0 14.0313-80 240 240 0 0 0 -13.9961-79.99997z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15613",
    d: "m2614.2266 1136.411a240 240 0 0 0 226.0039 160 240 240 0 0 0 225.9687-160z",
    fill: "#29a85e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15617",
    d: "m2892.7844 1164.4727-35.7034-50.2283 1.7009 60.9302-19.3121-58.5205-16.3342 58.7246-1.2048-61.613-32.9179 51.3011 17.0094-59.2308-46.5767 39.3192 33.7123-51.5858-56.0969 23.8436 47.4197-39.357-60.6327 6.2495 56.9137-23.6314-59.781-11.8999 61.3506-5.8059-53.6176-28.9921 60.3363 12.5355-42.6899-43.50802 53.9609 29.76292-27.9692-54.15814 42.7907 44.34594-10.7631-59.99614 27.8185 54.98857 7.3993-60.50316 10.3743 60.7452 24.9041-55.63422-7.9914 61.10435 40.1962-45.82189-25.6474 56.03409 51.9167-31.9381-41.0242 45.985 59.0241-15.2165-52.7559 31.8499 60.8868 2.8572-59.8 14.8849 57.3397 20.6769-61.5307-3.4028 48.6977 36.6595-57.7941-21.3881 35.7285 49.3847-48.9221-37.473z",
    fill: "#fcd116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKu);
export default __webpack_public_path__ + "static/media/ku.2bf98b1a240f0d984d5c50fc7e1abb5c.svg";
export { ForwardRef as ReactComponent };